<template>
  <div class="loading-overlay">
    <div class="spinner-container">
      <div class="spinner-border custom-spinner" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <span class="loading-text">Carregando...</span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'LoaderSpinner'
}
</script>

<style scoped>
.loading-overlay {
  position: fixed; /* Para cobrir toda a página */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6); /* Fundo mais escuro */
  display: flex; /* Usando flexbox para centralizar o conteúdo */
  justify-content: center;
  align-items: center;
  z-index: 100000; /* Certifique-se de que o overlay fique acima de outros elementos */
}

.spinner-container {
  text-align: center; /* Centralizar o texto e o spinner */
}

.custom-spinner {
  width: 6rem; 
  height: 6rem; 
  border-width: 1rem;
  color: #3a393a;
}

.loading-text {
  display: block; /* Garantir que o texto carregando fique abaixo do spinner */
  margin-top: 1rem; /* Espaçamento entre o spinner e o texto */
  color: #383838; /* Cor do texto */
  font-size: 2rem;
}
</style>
